// extracted by css-extract-rspack-plugin
export default {"applicantRsvVerificationCard":"applicant-rsv-verification-card--U1UL25tVyGcKe3Mt","hidePrint":"hide-print--Vgzlc7t52KELVTQn"};